import { z } from 'zod';
import { BaseResponseSchema, passwordSchema } from './primitives.js';
export const STEP_UP_AUTH_HEADER = 'X-Step-Up-Token';
export const StepUpActionSchema = z.enum([
    'reset-password',
    'resend-invitation',
    'enable-user',
    'disable-user',
    'delete-user',
    'change-role',
    'resend-tenant-invitation',
    'delete-tenant',
]);
export const StepUpAuthRequestSchema = z.object({
    password: passwordSchema,
    totpCode: z
        .string()
        .regex(/^\d{6}$/, 'TOTP code must be 6 digits')
        .optional(),
    action: StepUpActionSchema,
    targetId: z.string().min(1, 'Target id is required'),
});
export const StepUpAuthResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        stepUpToken: z.string().min(1),
        expiresIn: z.number().int().positive(),
        mfaRequired: z.boolean(),
    }),
});
//# sourceMappingURL=step-up-auth.schemas.js.map